export default "__VITE_ASSET__D34EXj0n__"